var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9668 3.39921L12.7392 2.62681C14.019 1.34705 16.0938 1.34705 17.3736 2.62681C18.6534 3.90656 18.6534 5.98145 17.3736 7.2612L16.6012 8.0336M11.9668 3.39921C11.9668 3.39921 12.0634 5.04056 13.5116 6.48881C14.9599 7.93705 16.6012 8.0336 16.6012 8.0336M11.9668 3.39921L4.86577 10.5002C4.3848 10.9812 4.14432 11.2217 3.9375 11.4869C3.69353 11.7996 3.48436 12.1381 3.3137 12.4962C3.16903 12.7997 3.06148 13.1224 2.84638 13.7677L1.93492 16.5021M16.6012 8.0336L9.50017 15.1346C9.0192 15.6156 8.77871 15.8561 8.51355 16.0629C8.20076 16.3069 7.86232 16.516 7.50423 16.6867C7.20066 16.8314 6.87802 16.9389 6.23273 17.154L3.49835 18.0655M3.49835 18.0655L2.82995 18.2883C2.5124 18.3941 2.1623 18.3115 1.92561 18.0748C1.68892 17.8381 1.60627 17.488 1.71212 17.1705L1.93492 16.5021M3.49835 18.0655L1.93492 16.5021",
    stroke: "#111111",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit1);
export default __webpack_public_path__ + "static/media/edit-1.f2b661b77b401773fdecb9287834e6b1.svg";
export { ForwardRef as ReactComponent };